<template>
  <EditDrawer
    :value="value"
    @input="$emit('input', $event)"
    :withHeader="true"
    :withFooter="true"
    :title="Lang.showColumns"
  >
    <div class="show-columns">
      <div class="show-columns__selection-wrapper">
        <div class="show-columns__selection">
          <div class="show-columns__selection-title">{{ Lang.dimensions }}</div>
          <div class="show-columns__selection-item" v-for="metric in metricsGroup('dimension')" :key="metric.value">
            <v-checkbox
              hide-details
              v-model="selected"
              :label="metric.title"
              :value="metric"
              :disabled="metric.persistent"
            />
          </div>
        </div>

        <div class="show-columns__selection">
          <div class="show-columns__selection-title">{{ Lang.standardMetrics }}</div>
          <div class="show-columns__selection-item" v-for="metric in metricsGroup('standard')" :key="metric.value">
            <v-checkbox
              hide-details
              v-model="selected"
              :label="metric.title"
              :value="metric"
              :disabled="metric.persistent"
            />
          </div>
        </div>

        <div class="show-columns__selection">
          <div class="show-columns__selection-title">{{ Lang.countableMetrics }}</div>
          <div class="show-columns__selection-item" v-for="metric in metricsGroup('calculated')" :key="metric.value">
            <v-checkbox
              hide-details
              v-model="selected"
              :label="metric.title"
              :value="metric"
              :disabled="metric.persistent"
            />
          </div>
        </div>
      </div>
    </div>

    <template v-slot:footer>
      <span class="footer-controls">
        <ButtonSecondary @click="onCancel" class="show-columns__cancel" :tooltip="Lang.cancel">
          {{ Lang.cancel }}
        </ButtonSecondary>
        <ButtonPrimary @click="onSaveColumns" class="show-columns__save" :tooltip="Lang.save">
          {{ Lang.save }}
        </ButtonPrimary>
      </span>
    </template>
  </EditDrawer>
</template>

<script lang="ts">
import Vue from "vue";

import ButtonPrimary from "@/components/customComponents/ButtonPrimary.vue";
import ButtonSecondary from "@/components/customComponents/ButtonSecondary.vue";
import EditDrawer from "@/components/drawers/EditDrawer.vue";
import Lang from "@/lang";
import inputsDictionary from "@/settings/planInputsDictionary";
import { PlanInputDictionary } from "@/types/common";

export default Vue.extend({
  name: "ProjectTableColumnsDrawer",

  components: {
    EditDrawer,
    ButtonPrimary,
    ButtonSecondary,
  },

  props: {
    value: Boolean,
    selectedHeader: Array as () => PlanInputDictionary[],
  },

  data() {
    return {
      Lang,
      selected: [] as PlanInputDictionary[],
      beforeCancelSelected: [] as PlanInputDictionary[],
    };
  },

  watch: {
    value: {
      handler(val) {
        if (val) {
          const allMetrics = inputsDictionary.tableMetrics as PlanInputDictionary[];
          this.selected = allMetrics.filter((m) => this.selectedHeader.some((s) => s.value === m.value));
          this.beforeCancelSelected = [...this.selected];
        }
      },
    },
  },

  methods: {
    onSaveColumns(): void {
      this.$emit("onColumnsChange", this.selected);
      this.$emit("input", false);
    },

    onCancel(): void {
      this.selected = [...this.beforeCancelSelected];
      this.$emit("input", false);
    },

    metricsGroup(group: string): PlanInputDictionary[] {
      return (inputsDictionary.tableMetrics as PlanInputDictionary[])
        .filter((m) => m.tableGroup === group)
        .sort((a, b) => a.title.localeCompare(b.title));
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/scss/theme.scss";
@import "@/scss/custom_variables.scss";

.show-columns {
  &__selection-wrapper {
    display: flex;
    justify-content: space-between;
  }
  &__selection {
    flex: 1;
  }
  &__selection-title {
    margin-bottom: $space-small-minus;
    font-weight: 500;
  }
}

.footer-controls {
  display: flex;
  margin-left: auto;
  gap: $space-smallest-minus;
}

::v-deep .v-input--selection-controls {
  margin-top: $space-small-minus !important;
  padding-top: 0 !important;
}
</style>
